import image from 'shared/assets/images/integrationsSliders/gdocs/gdocs1.png'
import { LINK_GDOCS_GUIDE } from 'shared/constants/links'
import { type IntegrationDetailsData } from 'entities/Integrations/lib/integrationsDescription'

export const gdocs: IntegrationDetailsData = {
  subheadline:
    'Connect Google Docs to give your AI agent access to your documents. Let your agent use structured content like FAQs, scripts, or internal knowledge to provide better responses.',
  overview:
    'Connect Google Docs to give your AI agent access to your documents. Let your agent use structured content like FAQs, scripts, or internal knowledge to provide better responses.',
  keyBenefits: [
    'Use content from Google Docs in AI responses',
    'Keep your knowledge base up to date automatically',
    'Great for FAQs, scripts, and internal documentation',
    'No need to re-upload or manage files manually',
  ],
  images: [image],
  docs: LINK_GDOCS_GUIDE,
}
